import 'angular-scroll/src/services/request-animation';
import 'angular-scroll/src/helpers';

/**
 * x is a value between 0 and 1, indicating where in the animation you are.
 */
var duScrollDefaultEasing = function (x) {
  'use strict';
  if (x < 0.5) {
    return Math.pow(x * 2, 2) / 2;
  }
  return 1 - Math.pow((1 - x) * 2, 2) / 2;
};

export default angular
  .module('doxy.angular-scroll', ['duScroll.scrollHelpers'])
  .value('duScrollDuration', 350)
  .value('duScrollSpyWait', 100)
  .value('duScrollSpyRefreshInterval', 0)
  .value('duScrollGreedy', false)
  .value('duScrollOffset', 0)
  .value('duScrollEasing', duScrollDefaultEasing)
  .value(
    'duScrollCancelOnEvents',
    'scroll mousedown mousewheel touchmove keydown'
  )
  .value('duScrollBottomSpy', false)
  .value('duScrollActiveClass', 'active').name;
